// Fetch wrapper for the pack-scene endpoint. Mirrors practiceApi.ts.

import {
  packBonusResponseSchema,
  packSceneResponseSchema,
  type PackBonusResponse,
  type PackId,
  type PackSceneResponse,
} from '@skena/schema'

interface ApiSuccess<T> {
  data: T
}
interface ApiError {
  error: { code: string; message: string; details?: unknown }
}
type ApiResult<T> = ApiSuccess<T> | ApiError

export class SceneApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly status: number,
  ) {
    super(message)
  }
}

export async function fetchPackScene(packId: PackId): Promise<PackSceneResponse> {
  const res = await fetch(`/api/packs/${packId}/scene`, { credentials: 'same-origin' })
  const json = (await res.json().catch(() => ({}))) as ApiResult<unknown>
  if (!res.ok || 'error' in json) {
    const err = 'error' in json ? json.error : { code: 'INTERNAL', message: 'unexpected error' }
    throw new SceneApiError(err.code, err.message, res.status)
  }
  return packSceneResponseSchema.parse(json.data)
}

export async function fetchPackBonus(packId: PackId): Promise<PackBonusResponse> {
  const res = await fetch(`/api/packs/${packId}/bonus`, { credentials: 'same-origin' })
  const json = (await res.json().catch(() => ({}))) as ApiResult<unknown>
  if (!res.ok || 'error' in json) {
    const err = 'error' in json ? json.error : { code: 'INTERNAL', message: 'unexpected error' }
    throw new SceneApiError(err.code, err.message, res.status)
  }
  return packBonusResponseSchema.parse(json.data)
}
